// extracted by mini-css-extract-plugin
export default {"rating":"wE-z","numberOfStars":"xE-z","count":"yE-z","barGraphSpacing":"zE-z","barGraph":"AE-z"};